export const TRANSACTIONS_FETCH = 'TRANSACTIONS_FETCH';
export const TRANSACTIONS_FETCH_DONE = 'TRANSACTIONS_FETCH_DONE';



// WEBPACK FOOTER //
// ./app/constants/transactionsTypes.js